import { gql } from '@apollo/client';

export const ALL_OUTCOMES = gql`
  query AllOutcomes {
    outcomes: getOutcomes {
      id
      name
      unit
      measurementUnit
    }
  }
`;
